import React from 'react';
import styled from 'styled-components';

import Link from '../Link';

const StyledLink = styled(Link)`
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: ${({ color }) =>
    color === 'black' || color === 'petrol' ? `var(--color-text-light)` : `var(--color-text-dark)`};
  background: ${({ color }) => (color ? `var(--color-${color})` : `var(--color-secondary)`)};
  display: inline-block;
  line-height: 1;
  appearance: none;
  border: none;
  box-shadow: none;
  border-radius: var(--border-radius-default) 0;
  outline: none;
  cursor: pointer;
  padding: 1.9rem 4rem 1.8rem;
  margin: 0;

  &:hover {
    background: var(--color-black);
    color: var(--color-secondary);
  }

  ${({ size }) =>
    size === 'half' &&
    `
    border-radius: 0;
    padding-right: 3rem;
    padding-left: 3rem;

    &:first-of-type {
      border-top-left-radius: var(--border-radius-default);
    }

    + a {
      border-bottom-right-radius: var(--border-radius-default);
    }
  `}

  @media (${({ theme }) => theme.respondTo.tablet}) {
    ${({ size }) =>
      size === 'large' &&
      `
      padding: 2.3rem 5rem 2.2rem;
    `}

    ${({ size }) =>
      size === 'extraLarge' &&
      `
      font-size: var(--font-size-md);
      padding: 2.4rem 5rem 2.3rem;
    `}
  }
`;

const ButtonLink = ({ href, type, color, half, large, children, ...rest }) => (
  <StyledLink href={href} type={type} color={color} half={half} large={large} {...rest}>
    {children}
  </StyledLink>
);

export default ButtonLink;
